import alertTemplate from '@/plugins/alert/AlertTemplate.vue'

export default {
  install(Vue, options) {
    const AlertConstructor = Vue.extend(Object.assign({ vuetify: options.vuetify }, alertTemplate))
    let alertInstance = null
    Vue.prototype.$alert = (config) => {
      if (alertInstance) {
        alertInstance.open = true
        return
      }

      alertInstance = new AlertConstructor({
        el: document.createElement('div'),
        data() {
          return {
            title: config.title || 'Aviso',
            message: config.message || '',
          }
        },
      })
      alertInstance.open = true
      document.body.appendChild(alertInstance.$el)
    }
  },
}
